import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const STATIONS = [
  { name: 'ST13 Giza', icon: '🏗️', color: '#1e3c72' },
  { name: 'ST14 Giza Square', icon: '🏛️', color: '#2a5298' },
  { name: 'S15 Alrawda', icon: '🌳', color: '#16a085' },
  { name: 'ST16 Almalek Elsaleh', icon: '👑', color: '#8e44ad' },
  { name: 'ST17 Cut&Cover', icon: '⚙️', color: '#c0392b' },
  { name: 'Abo Rawash', icon: '🏭', color: '#d35400' }
];

const Inventory = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleStationClick = (stationName) => {
    navigate(`/inventory/${encodeURIComponent(stationName)}`);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>☰</button>
          <h1>📦 إدارة المخزون</h1>
        </div>

        <div className="dashboard-main" style={{ padding: '20px' }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '40px',
            padding: '25px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '15px',
            color: 'white',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
          }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold' }}>
              مخزون معامل مشروع Metro4
            </h2>
            <p style={{ margin: '10px 0 0 0', fontSize: '16px', opacity: 0.9 }}>
              اختر المحطة لعرض وإدارة المخزون
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '20px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            {STATIONS.map((station) => (
              <div
                key={station.name}
                onClick={() => handleStationClick(station.name)}
                style={{
                  background: `linear-gradient(135deg, ${station.color} 0%, ${station.color}dd 100%)`,
                  borderRadius: '20px',
                  padding: '30px 20px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '180px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                }}
              >
                <div style={{
                  fontSize: '70px',
                  marginBottom: '15px',
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
                }}>
                  {station.icon}
                </div>
                <h3 style={{
                  margin: 0,
                  color: 'white',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  lineHeight: '1.4'
                }}>
                  {station.name}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inventory;